module.exports = __webpack_public_path__ + "img/sh-img2.bfce2d8f.png";